var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0H5.5C5.89782 0 6.27936 0.158035 6.56066 0.43934C6.84196 0.720644 7 1.10218 7 1.5V2.5C7 2.89782 6.84196 3.27936 6.56066 3.56066C6.27936 3.84196 5.89782 4 5.5 4H1.5C1.10218 4 0.720644 3.84196 0.43934 3.56066C0.158035 3.27936 0 2.89782 0 2.5V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0V0ZM10.5 12H14.5C14.8978 12 15.2794 12.158 15.5607 12.4393C15.842 12.7206 16 13.1022 16 13.5V14.5C16 14.8978 15.842 15.2794 15.5607 15.5607C15.2794 15.842 14.8978 16 14.5 16H10.5C10.1022 16 9.72064 15.842 9.43934 15.5607C9.15804 15.2794 9 14.8978 9 14.5V13.5C9 13.1022 9.15804 12.7206 9.43934 12.4393C9.72064 12.158 10.1022 12 10.5 12V12Z",
    fill: "rgba(173, 44, 211)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6H5.5C5.89782 6 6.27936 6.15804 6.56066 6.43934C6.84196 6.72064 7 7.10218 7 7.5V14.5C7 14.8978 6.84196 15.2794 6.56066 15.5607C6.27936 15.842 5.89782 16 5.5 16H1.5C1.10218 16 0.720644 15.842 0.43934 15.5607C0.158035 15.2794 0 14.8978 0 14.5V7.5C0 7.10218 0.158035 6.72064 0.43934 6.43934C0.720644 6.15804 1.10218 6 1.5 6V6ZM10.5 0H14.5C14.8978 0 15.2794 0.158035 15.5607 0.43934C15.842 0.720644 16 1.10218 16 1.5V8.5C16 8.89782 15.842 9.27936 15.5607 9.56066C15.2794 9.84196 14.8978 10 14.5 10H10.5C10.1022 10 9.72064 9.84196 9.43934 9.56066C9.15804 9.27936 9 8.89782 9 8.5V1.5C9 1.10218 9.15804 0.720644 9.43934 0.43934C9.72064 0.158035 10.1022 0 10.5 0Z",
    fill: "rgba(173, 44, 211)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4620f3c1a90a7221129787bec0d03522.svg";
export { ForwardRef as ReactComponent };